import React from 'react';
import { ScrollView, View } from 'react-native'

import tw from '../../../../styles/tailwind';
import Text from '../../../../components/Text';
import Toggle from '../../../../components/Toggle';
import Select from '../../../../components/Forms/Select';
import Header from '../../../../navigation/Header';
import useCommunitySettings from '../../../../hooks/useCommunitySettings';


/** Card con título + línea divisora del color del borde + contenido. */
function TitledCard({ title, children }: any) {
  return (
    <View style={tw`bg-white rounded-2xl border border-gray-200 px-4 py-4 mb-4`}>
      <Text style={tw`text-secondary font-600 text-base`}>{title}</Text>
      <View style={tw`border-b border-gray-200 -mx-4 mt-3 mb-4`} />
      {children}
    </View>
  )
}

function ToggleItem({ title, description, value, onValueChange, disabled, first }: any) {
  return (
    <View style={tw.style(!first && `mt-4`)}>
      <View style={tw`row items-center justify-between`}>
        <Text style={tw`text-secondary font-600 text-base flex-1 mr-3`}>{title}</Text>
        <Toggle value={value} onValueChange={onValueChange} disabled={disabled} />
      </View>
      <Text style={tw`text-gray-500 text-sm mt-1`}>{description}</Text>
    </View>
  )
}


const TOLERANCE_OPTIONS = [1, 2, 3, 4, 5, 6].map(n => ({ label: `${n}`, value: n }))


export default function MorosidadSettingsScreen() {
  const { updateSettings, getSettingValue, isUpdating } = useCommunitySettings()

  return (
    <View style={tw`flex-1 bg-[#F3F2F3]`}>
      <Header showBackButton title="Morosidad" style="bg-transparent" />

      <ScrollView style={tw`flex-1`} contentContainerStyle={tw`px-4 pt-4 pb-10`}>
        <TitledCard title="Tolerancia">
          <Text style={tw`text-gray-500 text-sm mb-3`}>
            El residente cambia a estatus de “Moroso” al no cubrir el pago de:
          </Text>

          <View style={tw`row items-center justify-between`}>
            <Text style={tw`text-secondary font-500 flex-1 mr-3`}>Cuota de mantenimiento</Text>
            <View style={tw`w-28`}>
              <Select
                value={getSettingValue('mora.tolerance_fees', 1)}
                items={TOLERANCE_OPTIONS}
                onChange={(v) => updateSettings('mora.tolerance_fees', v)}
                disabled={isUpdating}
                style={{ wrapper: tw`mb-0`, input: tw`bg-gray-100 rounded-lg py-2.5 text-secondary font-600` }}
              />
            </View>
          </View>
        </TitledCard>

        <TitledCard title="Consecuencias de morosidad">
          <ToggleItem
            first
            title="Inhabilitar códigos QR"
            description="El residente moroso no podrá generar códigos QR de acceso para invitados."
            value={getSettingValue('guest_passes.deactivate_on_debt', false)}
            onValueChange={(v: boolean) => updateSettings('guest_passes.deactivate_on_debt', v)}
            disabled={isUpdating}
          />
          <ToggleItem
            title="Desactivación de Tags vehiculares"
            description="Se desactivan automáticamente al cambiar al estatus de moroso."
            value={getSettingValue('tags.deactivate_on_debt', false)}
            onValueChange={(v: boolean) => updateSettings('tags.deactivate_on_debt', v)}
            disabled={isUpdating}
          />
          <ToggleItem
            title="Restringir acceso a áreas comunes"
            description="Los residentes morosos no tendrán acceso libre a las amenidades que cuenten con puertas electrónicas."
            value={getSettingValue('mora.restrict_amenities', false)}
            onValueChange={(v: boolean) => updateSettings('mora.restrict_amenities', v)}
            disabled={isUpdating}
          />
          <ToggleItem
            title="Inhabilitar Código Dinámico"
            description="Para el acceso al fraccionamiento deberá registrarse en caseta."
            value={getSettingValue('mora.disable_dynamic_code', false)}
            onValueChange={(v: boolean) => updateSettings('mora.disable_dynamic_code', v)}
            disabled={isUpdating}
          />
        </TitledCard>
      </ScrollView>
    </View>
  );
}
